<app-public-header></app-public-header>
<div class="w-full min-h-screen-safe flex flex-col items-center justify-center bg-westetics-purple-dark">
  <div class="lg:w-1/2 w-11/12 border rounded-2xl border-gray-300 shadow-xl lg:py-16 py-12 px-6 bg-white 
              flex flex-col gap-6 items-center justify-center text-center">
    
    <fa-icon [icon]="faCircleExclamation" class="text-red-500 text-7xl md:text-8xl"></fa-icon>
    
    <h1 class="text-3xl md:text-4xl font-bold text-gray-800">Anamnese Inválida ou Excluída</h1>
    
    <p class="text-lg md:text-xl text-gray-600 max-w-md">
      A anamnese que você está tentando acessar não é mais válida ou foi excluída.
    </p>
    <p class="text-base md:text-lg text-gray-500 max-w-md">
      Por favor, entre em contato com a clínica responsável para mais informações.
    </p>
    
    <button 
      (click)="goHome()"
      class="mt-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-10 rounded-lg shadow-md 
             focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 
             transition duration-150 ease-in-out text-base md:text-lg">
      Entendido
    </button>
  </div>
</div> 